module.exports = __webpack_public_path__ + "static/media/IMG_20181114_213102.7ec2a65b.jpg";